import '@common/styles/components/imprint.pcss';

function GermanImprint() {
  return (
    <div className="imprint txt-small">
      <h2>
        Impressum
      </h2>
      <article>
        <section>
          <h5>
            STIEBEL ELTRON GmbH &amp; Co. KG
          </h5>
        </section>
        <section>
          <span>
            <strong>
              Adresse:
            </strong>
            <br />
            Dr.-Stiebel-Straße 33, 37603 Holzminden
            <br />
            Telefon: 0 55 31 - 702 703
            <br />
            Telefax: 0 55 31 - 702 95 106
            <br />
            E-Mail: info-center@stiebel-eltron.de
          </span>
        </section>
        <section>
          <h5>
            Registergericht
          </h5>
          <span>
            Amtsgericht Hildesheim
            <br />
            Registernummer: HRA 110363
            <br />
            Umsatzsteuer-Identifikationsnummer: DE116005580
          </span>
        </section>
        <section>
          <h5>
            Persönlich haftende Gesellschafterin
          </h5>
          <span>
            STIEBEL ELTRON Geschäftsführungsgesellschaft mbH
            <br />
            Dr.-Stiebel-Straße 33
            <br />
            37603 Holzminden
          </span>
        </section>
        <section>
          <h5>
            Registergericht
          </h5>
          <span>
            Amtsgericht Hildesheim
            <br />
            Registernummer: HRB 110401
          </span>
        </section>
        <section>
          <h5>
            Vertretungsberechtigte Geschäftsführer
          </h5>
          <span>
            Dr. Kai Schiefelbein, Heinz-Werner Schmidt, Martin Repschlaeger
          </span>
        </section>
        <section>
          <h5>
            Vorsitzender des Aufsichtsrats
          </h5>
          <span>
            Dr. Ulrich Stiebel
          </span>
        </section>
        <section>
          <h5>
            Redaktion
          </h5>
          <span>
            Dominik Scholz
            <br />
            <a href="mailto:dominik.scholz@stiebel-eltron.de">
              dominik.scholz@stiebel-eltron.de
            </a>
          </span>
        </section>
        <section>
          <h5>
            Rechtshinweise / Gewährleistung
          </h5>
          <span>
            Eine Fehlerfreiheit der in diesem Medium enthaltenen Informationen kann trotz
            sorgfältiger Zusammenstellung nicht gewährleistet werden. Aussagen über Ausstattung und
            Ausstattungsmerkmale sind unverbindlich. Die in diesem Medium beschriebenen
            Ausstattungsmerkmale gelten nicht als vereinbarte Beschaffenheit unserer Produkte.
            Einzelne Ausstattungsmerkmale können aufgrund ständiger Fortentwicklung zwischenzeitlich
            verändert oder gar entfallen sein.
            <br />
            <br />
            Über die zurzeit gültigen Ausstattungsmerkmale informieren Sie sich bitte bei unserem
            Fachberater. Die bildliche Darstellung in diesem Medium stellen nur Anwendungsbeispiele
            dar. Die Abbildungen enthalten auch Installationsteile, Zubehör und Sonderausstattungen,
            die nicht zum serienmäßigen Lieferumfang gehören.
          </span>
        </section>
        <section>
          <h5>
            Haftungshinweis
          </h5>
          <span>
            Für Schäden gleich welcher Art, die aufgrund dieser Website bereitgestellten
            Informationen entstehen, haften wir nicht.
            <br />
            <br />
            Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
            externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
            verantwortlich.
          </span>
        </section>
        <section>
          <h5>
            Verbraucherschlichtung | Hinweis gemäß § 36 Abs. 1 VSBG
          </h5>
          <span>
            Wir sind nicht bereit und nicht verpflichtet, an einem Streitbeilegungsverfahren vor
            einer Verbraucherschlichtungsstelle teilzunehmen.
          </span>
        </section>
        <section>
          <h5>
            Urheberrecht
          </h5>
          <span>
            Wir möchten darauf hinweisen, dass der Inhalt dieser Website urheberrechtlich geschützt
            ist. Alle Texte, Darstellungen und Tondateien unterliegen dem Urheberrecht und anderen
            Gesetzen zum Schutze geistigen Eigentums. Sie dürfen weder für Handelszwecke noch zur
            Weitergabe kopiert, verändert oder auf anderen Websites verwendet werden. Dies gilt
            nicht, wenn wir Bildmaterial oder Grafiken zur Weiterverwendung ausdrücklich zur
            Verfügung stellen.
          </span>
        </section>
      </article>
    </div>
  );
}

export default GermanImprint;
